import AccessDeniedComponent from "./view";
const AccessDenied = ({ open = false }) => {
  return <AccessDeniedComponent isOpen={open} />;
};
export default AccessDenied;
